// MW persists profile languages as ISO 639-1 codes; the UI uses legacy keys.
export const normalizeProfileLanguage = (value) => {
  const language = String(value || "").trim().toLowerCase();
  if (["en", "eng", "english"].includes(language)) return "EN";
  if (["ar", "arb", "ara", "arabic"].includes(language)) return "AR";
  return null;
};

export const profileInterfaceLanguage = (value) =>
  ({ EN: "eng", AR: "arb" })[normalizeProfileLanguage(value)] || "eng";
